<template>
  <div class="loader">
    <Header :icons="headerIcons" />
    <div class="loading">
      <img src="/img/spinner.gif" />
      <div class="loading__text">Skoft<br>Wy gien aanst wer fierder...</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from "@/components/Header";

export default {
  components: {
    Header,
  },
  computed: {
    ...mapState(['config', 'kwis', 'time']),
    subscribed() {
      return this.kwis.team.id ? true : false
    },
    headerIcons() {
      if (this.subscribed) {
        return ['profile']
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.loader {
  height: 100vh;
}

.loading {
  width: 100%;
  height: calc(85vh - 250px);
  background-color: #ffeb94;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    max-width: 60%;
  }

  &__text {
    text-align: center;
    font-weight: 500;
  }
}
</style>
